<script setup lang="ts">
import { inject, Ref, ref, toRaw, onBeforeMount } from 'vue';
import Button from 'primevue/button';
import HTMLEditor from '@/components/common/HTMLEditor.vue';
import HtmlDiff from 'htmldiff-js';

const dialogRef = inject('dialogRef') as Ref;
const historyChange = dialogRef?.value?.data?.historyChange;
const headerTitle = dialogRef?.value?.data?.headerTitle;
const isRuleHistory = dialogRef?.value?.data?.isRuleHistory;
const historyRecord = dialogRef?.value?.data?.historyRecord;
const onClose = dialogRef?.value?.options.emits.onClose;
const highlightedNewText = ref(structuredClone(toRaw(historyChange.newValue)));
const finalHTML = ref('');

const highlightInsTags = (oldValue: string, newValue: string) => {
  const convertString = HtmlDiff.execute(oldValue, newValue);

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = convertString;

  const insTags = tempDiv.querySelectorAll('ins');

  insTags.forEach((insTag) => {
    insTag.style.backgroundColor = '#ffe4b5';
  });

  return tempDiv.innerHTML;
};

onBeforeMount(() => {
  finalHTML.value = highlightInsTags(historyChange.oldValue, highlightedNewText.value).replace(/<del[^>]*>.*?<\/del>/g, '');
});
</script>
<template>
  <div class="view-detail-history h-full">
    <div v-if="isRuleHistory" class="title-change">{{ $t('management.log.extended_history') }} - {{ $t('management.term_and_condition') }} : {{ historyRecord.rule }}</div>
    <div class="view-detail-history flex justify-content-between gap-4 h-full">
      <div class="history-content w-6">
        <div class="lead-promotions flex align-items-center justify-content-between">
          <span v-if="isRuleHistory">{{ historyRecord.change }}</span>
          <span v-else> {{ headerTitle }}</span>
        </div>
        <HTMLEditor :readonly="true" :modelValue="historyChange.oldValue" class="custom-editor" />
      </div>
      <div class="seperator min-h-full"></div>
      <div class="history-content w-6">
        <div class="lead-promotions flex align-items-center justify-content-between">
          <span v-if="isRuleHistory">{{ historyRecord.change }}</span
          ><span v-else> {{ headerTitle }} - {{ $t('management.log.updated').toUpperCase() }}</span>
        </div>
        <HTMLEditor v-if="finalHTML" :readonly="true" :modelValue="finalHTML" class="custom-editor" />
      </div>
    </div>
    <div class="flex justify-content-end mt-3">
      <Button id="btn-close" :label="$t('common.buttons.ok')" class="import-button" @click="onClose()" />
    </div>
  </div>
</template>
<style lang="scss" scoped>
.lead-promotions {
  background-color: rgb(115, 115, 115);
  color: $col-white;
  padding: 0.8rem 1.2rem;
  margin-top: 1rem;
  font-weight: 700;
}

.title-change {
  background-color: $col-primary;
  padding: 1.05rem 1.75rem;
  font-weight: 700;
  color: $col-white;
}

.seperator {
  width: 1px;
  background: $col-greymd;
}
:deep() {
  .ql-toolbar {
    display: none;
  }
  .highlight-insert {
    background-color: $col-peachdk;
  }
}

.text-areas {
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
}

.highlight-text-area {
  padding: 0.75rem;
  border: $border-greybd;
  border-radius: 4px;
  font-size: 1.4rem;
  white-space: pre-wrap;
  background-color: $col-white;
  height: auto;
  overflow-y: auto;
}

ins {
  background-color: #c8e6c9; /* Màu xanh cho phần thêm */
  text-decoration: none;
}
</style>
